var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTrolley(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FFEDB5"
    },
    cx: 256,
    cy: 256,
    r: 256
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FEE187"
    },
    d: "M326.632,502.125c82.911-23.75,148.599-88.257,173.996-170.46L347.164,177.957l-81.941,51.638 l-100.014-99.656l-41.872-5.123l65.41,65.41l54.612,157.427l-28.822,42.003L326.632,502.125z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D35933"
    },
    d: "M379.961,293.257l-116.283,42.355c-4.961,1.807-10.449-0.75-12.257-5.711l-36.242-99.502 c-1.807-4.961,0.75-10.449,5.711-12.257l116.283-42.355c4.961-1.807,10.449,0.75,12.257,5.711L385.672,281 C387.481,285.961,384.924,291.449,379.961,293.257z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B54324"
    },
    d: "M337.175,175.787l-58.582,21.339l42.787,117.47l58.582-21.339c4.961-1.807,7.52-7.294,5.711-12.257 l-36.242-99.502C347.624,176.537,342.137,173.98,337.175,175.787z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B54324"
    },
    d: "M307.762,223.653l-33.563,12.224c-4.213,1.534-8.871-0.636-10.405-4.849l0,0 c-1.534-4.213,0.636-8.871,4.849-10.406l33.563-12.224c4.213-1.534,8.871,0.636,10.405,4.849l0,0 C314.146,217.459,311.973,222.118,307.762,223.653z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#930000"
    },
    d: "M302.204,208.396l-17.222,6.273l5.556,15.257l17.222-6.273c4.213-1.534,6.384-6.194,4.849-10.406l0,0 C311.077,209.032,306.417,206.862,302.204,208.396z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EAA22F"
    },
    d: "M388.663,315.139L241.13,368.876l-75.271-206.655c-4.975-13.659-14.972-24.564-28.148-30.706 l-14.374-6.699l7.282-15.624l14.374,6.699c17.349,8.083,30.513,22.442,37.066,40.429l69.372,190.457l131.336-47.838L388.663,315.139 z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 324.558,
    y: 309.215,
    transform: "matrix(-0.9396 0.3422 -0.3422 -0.9396 799.4167 494.628)",
    style: {
      fill: "#E09112"
    },
    width: 63.033,
    height: 17.239
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#59595B"
    },
    cx: 246.277,
    cy: 357.831,
    r: 44.977
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#272525"
    },
    d: "M230.89,315.575c23.335-8.499,49.143,3.527,57.642,26.862s-3.527,49.143-26.862,57.642 L230.89,315.575z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#808183"
    },
    cx: 246.277,
    cy: 357.831,
    r: 27.253
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#59595B"
    },
    d: "M236.953,332.219c14.143-5.151,29.784,2.138,34.935,16.281s-2.138,29.784-16.281,34.935 L236.953,332.219z"
  }), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrolley);
export default __webpack_public_path__ + "static/media/trolley.8c6a5d32374a16c7601a49adc360c6ae.svg";
export { ForwardRef as ReactComponent };